import { useCallback, useState } from "react";
import { hasGroupId, toggleId } from "../AdminTeam/TrainerAssignmentsFields";

export function useTrainerGroupToggle({ groups, groupIds, onChangeAssignments }) {
  const [pendingRemove, setPendingRemove] = useState(null);

  const toggleGroup = useCallback(
    (id) => {
      if (!onChangeAssignments) return;
      if (!hasGroupId(groupIds, id)) {
        onChangeAssignments({ groupIds: toggleId(groupIds, id) });
        return;
      }
      const group = groups.find((g) => String(g.id) === String(id));
      setPendingRemove({
        id,
        name: group?.name || "группа",
      });
    },
    [groupIds, groups, onChangeAssignments],
  );

  const confirmRemove = useCallback(() => {
    if (!pendingRemove || !onChangeAssignments) return;
    onChangeAssignments({ groupIds: toggleId(groupIds, pendingRemove.id) });
    setPendingRemove(null);
  }, [groupIds, onChangeAssignments, pendingRemove]);

  const cancelRemove = useCallback(() => setPendingRemove(null), []);

  return {
    toggleGroup,
    pendingRemove,
    confirmRemove,
    cancelRemove,
  };
}
